<template>
    <div class="overflow-auto mb-4 pb-3">
        <table class="display table nowrap table-striped table-vcenter w-100 px-auto mx-auto">
            <thead>
                <tr>
                    <th class="text-left fw-semibold text-nowrap fs-sm">{{ $t('calendar.modal.product') }}</th>
                    <th class="text-center fw-semibold text-nowrap fs-sm">{{ $t('calendar.modal.days_count') }}</th>
                    <th class="text-center fw-semibold text-nowrap fs-sm">{{ $t('calendar.modal.status') }}</th>
                    <th class="text-center fw-semibold text-nowrap fs-sm">{{ $t('calendar.modal.actions') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in product" :key="item.id">
                    <td class="text-left text-nowrap">{{ item.name }}</td>
                    <td class="text-center text-nowrap">{{ item.diff }}</td>
                    <td class="text-center text-nowrap" v-if="item.product_conso < item.days">
                        <span>{{ $t('calendar.modal.finished') }}</span>
                    </td>
                    <td class="text-center text-nowrap" v-else>
                        <span>{{ $t('calendar.modal.in_progress') }}</span>
                    </td>

                    <td class="text-center">
                        <div class="dropdown d-inline-block">
                            <button
                                type="button"
                                class="dropdown-button"
                                id="page-header-action-dropdown"
                                data-bs-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path
                                        d="M5 10C3.9 10 3 10.9 3 12C3 13.1 3.9 14 5 14C6.1 14 7 13.1 7 12C7 10.9 6.1 10 5 10ZM19 10C17.9 10 17 10.9 17 12C17 13.1 17.9 14 19 14C20.1 14 21 13.1 21 12C21 10.9 20.1 10 19 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
                                        fill="#94A3B8"
                                    />
                                </svg>
                            </button>
                            <div
                                class="dropdown-menu dropdown-action dropdown-menu-end rounded-24"
                                aria-labelledby="page-header-action-dropdown"
                                data-popper-placement="bottom-end"
                            >
                                <a
                                    class="btn btn-sm btn-action m-1"
                                    onMouseOver="this.style.cursor='pointer'"
                                    @click="ressort(item)"
                                >
                                    {{ $t('common.delete') }}
                                </a>

                                <a
                                    class="btn btn-sm btn-action m-1"
                                    onMouseOver="this.style.cursor='pointer'"
                                    @click="addToCard(item)"
                                    :title="$t('calendar.modal.create_sale_product')"
                                >
                                    {{ $t('calendar.modal.create_sale') }}
                                </a>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { sync, get } from 'vuex-pathify'
import ApiManager from '../_core/ApiManager'

export default {
    props: ['order'],
    mounted() {
        this.getproductByUser(this.order.user_id)
        this.getUser(this.order.user_id)
        this.getOrder(this.order.id)
    },
    data: () => {
        return {
            product: [],
            user_id: 0,
            order_id: 0,
        }
    },
    methods: {
        async getproductByUser(user_id) {
            await ApiManager.loadProductById(user_id).then((res) => {
                this.product = res
            })
        },
        async ressort(item) {
            await ApiManager.ressort(item.id).then(() => {})
            this.getproductByUser(this.user_id)
        },
        async addToCard(item) {
            await ApiManager.addToCardByOrder(item.product_id, this.user_id, this.order_id).then((res) => {
                if (res.status) {
                    return (location.href = 'caisse?order=' + res.order_id)
                }
            })
        },
        getUser(user_id) {
            return (this.user_id = user_id)
        },
        getOrder(order_id) {
            return (this.order_id = order_id)
        },
    },
}
</script>
